import React from "react";

const ResourceSectionPlaceholder = ({ title }) => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">{title}</h2>
    <div className="rounded-2xl border border-dashed border-[#cad8e6] bg-white px-5 py-8 text-[15px] font-medium text-[#0f5c66] shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
      Content will be added here.
    </div>
  </section>
);

export default ResourceSectionPlaceholder;
